export default __webpack_public_path__ + "static/media/first.634f840a.png";